import { useLocation } from 'react-router-dom';
import {
  UnblockEmailWrapper,
  Container,
  Row,
  TitleContainer,
  ButtonContainer,
  PageTitle,
  HelperText,
  UnblockButton,
} from './styles';
import { ReactComponent as ExclamationCircle } from 'images/shared/exclamation-circle.svg';

function Auth0EmailUnblock () {
  document.title = 'PKD Unblock Your Email Address';

  const params = useLocation();

  const unblock = () => {
    const queryParams = new URLSearchParams(params.search);
    const url = queryParams.get('url');

    window.location.replace(url);
  };

  return (
    <UnblockEmailWrapper>
      <Container>
        <Row>
          <ExclamationCircle
            width='295' height='181'
          />
        </Row>
        <TitleContainer>
          <PageTitle
            varient='h2'>You’re almost there</PageTitle>
        </TitleContainer>
        <Row>
          <HelperText
            varient='pl3'>
            Unblock your email by pressing ‘Unblock’ below.
          </HelperText>
        </Row>
        <ButtonContainer>
          <UnblockButton
            onClick={unblock} fullWidth>
            Unblock
          </UnblockButton>
        </ButtonContainer>
      </Container>
    </UnblockEmailWrapper>
  );
}

export default Auth0EmailUnblock;
